module.exports = __webpack_public_path__ + "img/caja.ac691099.svg";